import { restRequest } from "vrcore-dashboard/dist/utilities";

export const GET_QUALIFICATIONS = restRequest("QUALIFICATIONS.GET_QUALIFICATIONS");
export const ADD_QUALIFICATION = restRequest("QUALIFICATIONS.ADD_QUALIFICATION");
export const GET_REPORT_TITLES = restRequest("QUALIFICATIONS.GET_REPORT_TITLES");
export const EDIT_QUALIFICATION = restRequest("QUALIFICATIONS.EDIT_QUALIFICATION");
export const REMOVE_QUALIFICATION = restRequest("QUALIFICATIONS.REMOVE_QUALIFICATION");
export const GET_REGISTERED_USERS = restRequest("QUALIFICATIONS.GET_REGISTERED_USERS");

export const POST_EDITED_USER_QUALS = restRequest("QUALIFICATIONS.POST_EDITED_USER_QUALS");
